// extracted by css-extract-rspack-plugin
export default {"wbs__id":"wbs__id-MntO3t","wbsId":"wbs__id-MntO3t","wbs__title":"wbs__title-GNMo9i","wbsTitle":"wbs__title-GNMo9i"};